var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-centered lb-media-link"},[_c('a',{staticClass:"button is-link is-fullwidth",attrs:{"href":_vm.url,"target":"_blank"}},[_c('span',[_vm._v(_vm._s(_vm.$t('Object.url_more_info')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }